import { categories, mainSiteUrl } from "@/mocks/categories";
import { Link } from "react-router-dom";

const midPoint = Math.ceil(categories.length / 3);

const articleLinks = [
  { to: "/hoobuyspreadsheet", label: "Guia Completo 2026" },
  { to: "/guia-iniciantes-hoobuy", label: "Para Iniciantes" },
  { to: "/verificar-links-hoobuy", label: "Verificar Links" },
  { to: "/top-produtos-hoobuy-2026", label: "Top Produtos" },
  { to: "/comparacao-agentes-hoobuy", label: "Comparativo Agentes" },
  { to: "/guia-tamanhos-hoobuy", label: "Guia de Tamanhos" },
  { to: "/erros-comuns-hoobuy", label: "Erros Comuns" },
  { to: "/dicas-envio-internacional", label: "Dicas de Envio" },
  { to: "/faq-hoobuy-spreadsheet", label: "FAQ" },
  { to: "/historias-sucesso-hoobuy", label: "Histórias Reais" },
];

export default function Footer() {
  const col1 = categories.slice(0, midPoint);
  const col2 = categories.slice(midPoint, midPoint * 2);
  const col3 = categories.slice(midPoint * 2);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const hp = (form.querySelector(".newsletter-hp") as HTMLInputElement);
    if (hp && hp.value.trim() !== "") return;

    const formData = new FormData(form);
    fetch("https://readdy.ai/api/form/d8v90pg4jh3v1cgksdl0", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
    })
      .then(() => {
        const msg = document.getElementById("newsletter-msg");
        if (msg) {
          msg.textContent = "Inscrição realizada com sucesso!";
          msg.className = "text-secondary-600 text-xs mt-2";
        }
        form.reset();
      })
      .catch(() => {
        const msg = document.getElementById("newsletter-msg");
        if (msg) {
          msg.textContent = "Erro ao inscrever. Tente novamente.";
          msg.className = "text-red-500 text-xs mt-2";
        }
      });
  };

  return (
    <footer className="bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* Left */}
          <div className="lg:w-[35%] flex flex-col">
            <Link to="/" className="inline-block">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 tracking-tight">
                Hoobuy<span className="text-accent-500">.Tattoo</span>
              </h2>
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-sm">
              O seu portal de confiança para o hoobuy spreadsheet atualizado. Links verificados e produtos selecionados.
            </p>

            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="mt-8"
            >
              <label htmlFor="footer-email" className="block text-xs font-medium text-foreground-500 mb-2">
                Receba atualizações
              </label>
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  id="footer-email"
                  name="email"
                  type="email"
                  required
                  placeholder="seu@email.com"
                  className="flex-1 px-4 py-2.5 text-sm bg-white border border-background-300/60 rounded-lg focus:outline-none focus:border-accent-400 transition-colors text-foreground-800 placeholder:text-foreground-300"
                />
                <input
                  type="text"
                  name="website_alt"
                  className="newsletter-hp"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 text-sm font-medium text-foreground-700 border border-foreground-300/60 rounded-lg hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Subscrever
                </button>
              </div>
              <div id="newsletter-msg"></div>
            </form>
          </div>

          {/* Right - Links */}
          <div className="lg:w-[65%] grid grid-cols-2 sm:grid-cols-4 gap-8">
            {/* Column 1: Categorias */}
            <div className="flex flex-col gap-2.5">
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-1">
                Categorias
              </h4>
              {col1.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.namePt}
                </a>
              ))}
            </div>

            {/* Column 2: Mais Categorias */}
            <div className="flex flex-col gap-2.5">
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-1">
                Mais
              </h4>
              {col2.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.namePt}
                </a>
              ))}
              {col3.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.namePt}
                </a>
              ))}
            </div>

            {/* Column 3: Artigos SEO */}
            <div className="flex flex-col gap-2.5">
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-1">
                Artigos SEO
              </h4>
              {articleLinks.slice(0, 5).map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Column 4: Links */}
            <div className="flex flex-col gap-2.5">
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-1">
                Links
              </h4>
              {articleLinks.slice(5).map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/hoobuyspreadsheet"
                className="text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Guia Completo
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Site Principal
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 Hoobuy.Tattoo. Todos os direitos reservados.
          </p>
          <p className="text-xs text-foreground-400">
            Aviso: Não somos responsáveis por compras externas. Sempre verifique os links antes de comprar.
          </p>
        </div>
      </div>
    </footer>
  );
}